/**
 * @generated SignedSource<<4500734cc0cf989793184cec0657a049>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleTopicsContent$data = {
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
    readonly entityUuid: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "topicLinkTopic">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "articleTopicsContent";
};
export type articleTopicsContent$key = {
  readonly " $data"?: articleTopicsContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleTopicsContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleTopicsContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Topic",
      "kind": "LinkedField",
      "name": "topics",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "topicLinkTopic"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityFollowButtonBase"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityUuid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "717cdc40353c44a2d3a595f238d3dd21";

export default node;
